import {Trans} from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { useAuth } from '@common/auth/use-auth';
import { useAnalyzeAction } from '@app_modules/requests/use-analyze-action';
import { useEffect, useState } from 'react';

export function AnalyzeAction({
  id,
  market_rate_date,
  loan_program_type,
  investor_code,
  sheet_name,
  description,
  analysis_prompt,
  subCheckList,
  pindex,
  onProcess,
}: {id: number, market_rate_date: string, pindex: number, loan_program_type: string, investor_code: string, sheet_name: string, subCheckList: any, description: string, analysis_prompt: string, onProcess?: any}) {
  return (
    <div className='flex w-full gap-10'>
      <ExecuteAction id={id} onProcess={onProcess} key={`exe-${pindex}`} market_rate_date={market_rate_date} loan_program_type={loan_program_type} investor_code={investor_code} sheet_name={sheet_name} description={description} analysis_prompt={analysis_prompt}/>
    </div>
  );
}

type ExecuteActionProps = {
  id: number,
  market_rate_date: string;
  loan_program_type: string, 
  investor_code: string;
  sheet_name: string;
  description: string;
  analysis_prompt: string;
  onProcess: any
};
export function ExecuteAction( {id, market_rate_date, loan_program_type, investor_code, sheet_name, description, analysis_prompt, onProcess}: ExecuteActionProps) {
  
  // const files = fileItems.length > 0 ? fileItems[0]['files'] : [];
  // const {user} = useAuth();

  const executeAnalyzeAction = useAnalyzeAction(id, market_rate_date, loan_program_type, investor_code, sheet_name, description, analysis_prompt);

  // const [executePending, setExecutePending] = useState(executeAnalyzeAction.isPending);

  useEffect(() => {
    // setExecutePending(executePending);
    onProcess(executeAnalyzeAction);

  }, [executeAnalyzeAction]);

  return (
    <>
      <Button
        size={'xs'} variant="flat" color="primary"
        type="submit"
        onClick={() => {
          executeAnalyzeAction.mutate(
            {id: id, market_rate_date: market_rate_date, loan_program_type: loan_program_type, investor_code: investor_code, sheet_name: sheet_name, description: description, analysis_prompt: analysis_prompt},
            {
              onSuccess: (response) => {
                //onProcess(response.status);
              },

            },
          );
        }}
        disabled={executeAnalyzeAction.isPending || !loan_program_type || !investor_code || !sheet_name || !analysis_prompt}
        >
        <Trans message={`Analyze`} />
      </Button>

    </>

  );
}
